/*
 * Copyright (c) Nexign, JSC, 2022-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.19.0
 */

import { useTableFilterApi, useTableListApi, useTableMetaApi, useTableResizeApi } from './api';
import {
    ITableButton,
    ITableMetaResponse,
    TTableFilterDateResponse,
    TTableFilterMultiSelectResponse,
    TTableFilterRangeResponse,
    TTableFilterSelectResponse,
} from './api/types';
import { TableColumnCheckbox } from './components/Basket';
import type { ITableLinkProps } from './components/Cell';
import {
    TableCell,
    TableCellBalance,
    TableCellIconButton,
    TableCellDate,
    TableCellLabel,
    TableCellLink,
    TableCellNoValue,
    TableCellStatus,
    TableCellStatusBlock,
    TableCellText,
    TableCellLinkTooltipText,
    useTableCellAccount,
    useTableCellCampaign,
    useTableCellCampaignInfo,
    useTableMsisdnCell,
} from './components/Cell';
import {
    ITableFilterMultiSelect,
    TableFilterInputSearch,
    TableFilterLabels,
    TableFilterMultiSelect,
    TableFilterRange,
    TableFilterRangeDatePicker,
    TableFilterSelect,
} from './components/Filter';
import Table from './components/Table';
import TableHeader from './components/TableHeader';
import { useTableInitialise } from './hooks/useTableInitialise';
import { tableListenerMiddleware } from './middleware/tableInitializeMIddleware';
import { TableDensity } from './modules/Density';
import { TableExport } from './modules/Export';
import { initialise } from './slice';
import { TTableColumnConfig } from './types';

export type {
    ITableButton,
    ITableFilterMultiSelect,
    ITableLinkProps,
    ITableMetaResponse,
    TTableColumnConfig,
    TTableFilterDateResponse,
    TTableFilterMultiSelectResponse,
    TTableFilterRangeResponse,
    TTableFilterSelectResponse,
};

export {
    Table,
    /* Cell */
    TableCell,
    TableCellBalance,
    TableCellIconButton,
    TableCellDate,
    TableCellLabel,
    TableCellLink,
    TableCellStatus,
    TableCellStatusBlock,
    TableCellLinkTooltipText,
    useTableCellAccount,
    useTableCellCampaign,
    useTableCellCampaignInfo,
    useTableMsisdnCell,
    TableCellNoValue,
    TableCellText,
    /* Filter & Header */
    TableFilterInputSearch,
    TableFilterLabels,
    TableFilterMultiSelect,
    TableFilterRange,
    TableFilterRangeDatePicker,
    TableFilterSelect,
    TableHeader,
    /* Basket */
    TableColumnCheckbox,
    /* Api */
    useTableResizeApi,
    useTableFilterApi,
    useTableMetaApi,
    useTableListApi,
    // modules
    TableExport,
    TableDensity,
    // slice
    useTableInitialise,
    initialise,
    tableListenerMiddleware,
};
